import { render, staticRenderFns } from "./DashboardIconV2.vue?vue&type=template&id=39d3c7ee"
import script from "./DashboardIconV2.vue?vue&type=script&lang=js"
export * from "./DashboardIconV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports